import { Get } from 'domain/infra/data/api';
import { CampanhaProdutoResponse } from '../../types/produto/CampanhaProdutoResponse';
import campanhaConstants from '../../infra/data/campanhaConstants';
import { CampanhaResumoResponse } from '../../types/produto/CampanhaResumoResponse';

export class CampanhaProdutosService {
  constructor() {
  }

  GetByUsuarioCampanha(usuarioId: number, campanhaId: number): Promise<CampanhaProdutoResponse[] | Error> {
    return Get(`${campanhaConstants.apiCampanha.CampanhasProduto.GetByUsuarioCampanha}?usuarioId=${usuarioId}&campanhaId=${campanhaId}`)
  }

  GetResumoCampanha(usuarioId: number, campanhaId: number, campanhaPedidoResgateId: number): Promise<CampanhaResumoResponse | Error> {
    return Get(`${campanhaConstants.apiCampanha.CampanhasProduto.GetResumoCampanha}?usuarioId=${usuarioId}&campanhaId=${campanhaId}&campanhaPedidoResgateId=${campanhaPedidoResgateId}`)
  }
}